/**
 * Hash Map that stores the hash of the srcs as key and the first valid src as value.
 */
export class SrcsCache {
    static _instance;
    map = new Map();
    constructor() { }
    static getInstance() {
        if (!SrcsCache._instance)
            SrcsCache._instance = new SrcsCache();
        return SrcsCache._instance;
    }
    set(srcs, src) {
        if (!srcs)
            return;
        const hash = this.hashFunction(srcs);
        this.map.set(hash, src);
    }
    get(srcs) {
        if (!srcs?.length)
            return;
        const hash = this.hashFunction(srcs);
        return this.map.get(hash);
    }
    hashFunction(srcs) {
        return srcs.join('|');
    }
}
